var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M80,212V448a16,16,0,0,0,16,16h96V328a24,24,0,0,1,24-24h80a24,24,0,0,1,24,24V464h96a16,16,0,0,0,16-16V212","style":{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":0}),React.createElement("path",{"d":"M480,256,266.89,52c-5-5.28-16.69-5.34-21.78,0L32,256","style":{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":1}),React.createElement("polyline",{"points":"400 179 400 64 352 64 352 133","style":{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":2})]);
}

Home.defaultProps = {"viewBox":"0 0 512 512","fill":"none","stroke":"currentColor"};

module.exports = Home;

Home.default = Home;
